import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import EditorLink from 'lowcode/components/EditorLink';
import styled from './index.module.scss';
import IconClose from './IconClose';
import { getShareInfo, sendInviteEmail } from '@/service/referral';
import { loginUser } from '@/utils/cookie';
import getLocal from '@/app/utils/getLocal';
import FaceBookIcon from '@/components/UI/svg/Referral/Icon/FaceBookIcon';
import { TwitterIcon } from '@/components/UI/svg/Referral';
import { message } from '@/components/UI/Message';
import { copyText } from '@/utils';
import { useLang } from '@/i18n';
import { ReferralInfoText } from '@/components/MembersDay/FY2024/AnnualSummary/elements/ReferralInfo/textLang';

// import Referra
interface IProps {
    planData: any;
    callback: (val?: string) => void;
}

const reg = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
const WinShare: FC<IProps> = ({ planData, callback }) => {
    const [isClient, setIsClient] = useState(false);
    const { locale, pathname } = getLocal();
    const { t } = useLang('membersday.teaser.ReferralNext.WinShare');
    const [show, setShow] = useState(false);
    const [failTips, setFailTips] = useState('');

    const [copyValue, setCopyValue] = useState('');
    const [sendEmail, setSendEmail] = useState('');
    const [referralInfo, setReferralInfo] = useState<any>({});
    const [shareInfo, setShareInfo] = useState<any>({});
    const textA = ReferralInfoText[locale] || ReferralInfoText['en'];
    // const [checked, setChecked] = useState(false);
    // 分享文案
    const shareText = {
        faceBook: `${t('share_text')}\n${copyValue}`,
        twitter: `${t('share_text')}\n${copyValue}`,
    };

    const initData = async () => {
        // 获取分享码
        const share = await getShareInfo({ planId: planData.planId, shareUrl: `${location.origin}/${locale}/referral-rewards` }, locale);
        if (share.code !== '0') return message.error(share.message);

        setReferralInfo(planData);
        setShareInfo(share.data);
        setCopyValue(`${location.origin}/${locale}/referral-rewards?inviteCode=${share.data?.inviteCode}`);
    };

    const handleSendMsg = () => {
        if (!referralInfo || !shareInfo) return;
        const { email } = loginUser().user;
        // 如果与用户邮箱相同提示
        if (email && email === sendEmail.trim()) return message.error(t('thesameemail'));
        if (!sendEmail || !reg.test(sendEmail)) {
            return;
            // return setFailTips('fail-1');
        }
        // if (!reg.test(sendEmail)) {
        //     return setFailTips('fail-1');
        // }
        sendInviteEmail(
            {
                planId: referralInfo?.planId,
                shareEmail: sendEmail.trim(),
                shareId: shareInfo?.shareId,
                shareUrl: copyValue,
            },
            locale,
        )
            .then((res) => {
                if (res.code !== '0') return message.error(res.message);
                message.success(textA.site_account_profile_save_success);
                // setFailTips('success');
                setSendEmail('');
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        planData?.planId && initData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [planData]);

    if (!isClient || show) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`glo-editor-modal glo-editor-modal-show ${styled.WinShare}`}>
            <div className="glo-editor-modal-wrap">
                <div className="modal-content">
                    <IconClose
                        className="win-close"
                        onClick={() => {
                            callback && callback();
                        }}
                    />
                    <div className="refer_box">
                        <p className="refer_title">{t('referTitle')}</p>
                        <p className="refer_subtitle">{t('referSubtitle')}</p>
                        <p className="line"></p>
                        <p className="refer_title2">{t('shareLink')}</p>
                        <div className="copy_content">
                            <input className="refer_input" value={copyValue} disabled />
                            <EditorLink
                                className="refer_modal_btn"
                                onClick={() => {
                                    copyText(copyValue);
                                    message.success(textA.site_account_profile_save_success);
                                }}
                            >
                                {t('copybtn')}
                            </EditorLink>
                        </div>
                        <p className="line">
                            <span>{t('line')}</span>
                        </p>
                        <p className="refer_title2">{t('emailtofriend')}</p>
                        <input
                            className="send_input"
                            value={sendEmail}
                            onChange={(e: any) => {
                                setSendEmail(e.target.value);
                                setFailTips('');
                            }}
                            placeholder={t('input')}
                        />
                        <div className="send_input_tips">
                            {failTips === 'fail-1' && <div className="send_input_tips_err">{textA.site_bottom_subscription_tip_two}</div>}
                            {failTips === 'success' && <div className="send_input_tips_success">{textA.site_bottom_subscription_sms_phone_thank}</div>}
                        </div>
                        <EditorLink className="sendmsg_btn" onClick={handleSendMsg} disabled={!reg.test(sendEmail)}>
                            {t('sendBtn')}
                        </EditorLink>
                        <p className="line">
                            <span>{t('line')}</span>
                        </p>
                        <div>
                            <EditorLink href={`https://www.facebook.com/sharer/sharer.php?u=${copyValue}`} traget="_blank">
                                <FaceBookIcon />
                            </EditorLink>
                            <EditorLink href={`https://twitter.com/intent/tweet?text=${shareText.twitter}`} traget="_blank">
                                <TwitterIcon />
                            </EditorLink>
                        </div>
                        <div className="referral_tips">{t('share_footer_info')}</div>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default WinShare;
